/* Printers Store */

import {fetchPrinters} from '@/api'

const state = {
    printers: []
}

const actions = {
    fetchPrinters (context, params) {
        return fetchPrinters(params).then(r => {
            context.commit('setPrinters', r.data)
        })
    }
}

const mutations = {
    setPrinters (state, payload) {
        state.printers = payload
    }
}

const getters = {
    getPrinters (state) {
        return state.printers
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
